import { render } from "./FilmOrCategoryModal.vue?vue&type=template&id=4e977230&scoped=true"
import script from "./FilmOrCategoryModal.vue?vue&type=script&lang=js"
export * from "./FilmOrCategoryModal.vue?vue&type=script&lang=js"

import "./FilmOrCategoryModal.vue?vue&type=style&index=0&id=4e977230&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e977230"]])

export default __exports__